export default {
	title: 'Valere Seniorenpflege und Wohnen Delitzsch GmbH',
	gsmaterials: {
		app: {
			scrollTop: {
				offset: 250,
				size: 'md',
				icon: 'i-mdi-chevron-up',
				class: 'z-20 bg-accent right-5 sm:right-10 hover:bg-primary transition-colors duration-300 ease-in-out'
			},
		},
		apiData: {
			profile: {
				url: '/rest/profiles',
				watch: false,
				query: () => {  return {id:  useRuntimeConfig().public.profileId}},
				frozen: ['id'],
				preload: true
			},
			locations: {
				url: '/rest/locations',
				query: { is_active: true },
				frozen: ['is_active'],
				watch: false,
				preload: false
			},
			teams: {
				url: '/rest/teams',
				query: () => { return { is_active: true, is_intern: false }},
				frozen: ['is_active', 'is_intern'],
				watch: false,
				preload: false
			},
			teams_members: {
				url: '/rest/team/{key}/memberships',
				watch: false
			},
			faq_topic_items: {
				url: '/rest/faq-topic/{key}/items'
			},
			advantages: {
				url: '/rest/advantages',
				preload: true
			},
			home_teaser: {
				url: '/rest/home-teasers',
				preload: true
			},
			slider_items: {
				url: '/rest/slideritems',
				query: { is_active: true },
				frozen: ['is_active'],
				preload: true
			},
			article_teaser: {
				url: '/rest/article-teasers',
				query: () => { return { is_active: true }},
				frozen: ['is_active'],
				watch: true,
				preload: false
			},
			location_teaser: {
				url: '/rest/location-teasers',
				query: () => { return { is_active: true }},
				frozen: ['is_active'],
				watch: true,
				preload: false
			},
			news: {
				url: '/rest/articles',
				query: () => {
					return {
						type: 'newsArticle',
						is_active: true,
						sort: '-publish_date',
						page: 1,
						page_size: 25
					}
				},
				frozen: ['type', 'is_active', 'sort', 'page_size'],
				watch: true,
				preload: false
			},
			home_news: {
				url: '/rest/home-news',
				watch: false,
				preload: true
			},
		}
	},
	ui: {
		button: {
			base: 'inline-flex items-center justify-center [&_span]:font-bold no-underline [&_.iconify]:me-2 rounded-full [&_span]:text-white px-6 py-3 md:px-8 md:py-4 cursor-pointer transition duration-300 ease-in-out' +
				'[html[data-contrast="high-light"]_&]:text-black! [html[data-contrast="high-light"]_&>span]:text-black [html[data-contrast="high-light"]_&]:hover:bg-gray-200 [html[data-contrast="high-light"]_&]:ring-black [html[data-contrast="high-light"]_&]:ring-2',
			defaultVariants: {
				size: '2xl',
				color: 'primary',
				variant: 'solid'
			},
			compoundVariants: [
				{
					color: 'primary',
					variant: 'solid',
					class: 'bg-primary-50 hover:bg-accent [html[data-contrast="high-light"]_&]:bg-gray-100'
				},
				{
					color: 'accent',
					variant: 'solid',
					class: 'hover:bg-primary hover:text-white [html[data-contrast="high-light"]_&]:bg-gray-100'
				},
				{
					color: 'secondary',
					variant: 'solid',
					class: 'bg-gray-50! [&>span]:text-gray-500 hover:bg-accent! hover:[&>span]:text-white [html[data-contrast="high-light"]_&]:bg-gray-100'
				},
				{
					color: 'dark',
					variant: 'solid',
					class: 'bg-gray-500 hover:bg-primary-50 hover:text-white [html[data-contrast="high-light"]_&]:bg-gray-100'
				},
				{
					color: 'info',
					variant: 'solid',
					class: 'bg-black! hover:bg-black-/90! [html[data-contrast="high-light"]_&]:bg-white! [html[data-contrast="high-light"]_&]:text-black [html[data-contrast="high-dark"]_&]:ring-2 [html[data-contrast="high-dark"]_&]:ring-white'
				},
				{
					color: 'neutral',
					variant: 'link',
					class: 'text-gray-500 [&_.iconify]:text-gray-500 bg-transparent hover:[&_.iconify]:text-accent p-0! [&_.iconify]:size-8'
				}
			]
		},
		checkbox: {
			slots: {
				base: 'cursor-pointer',
				label: 'block text-[1rem] text-primary-500 mb-1 font-medium leading-6 cursor-pointer',
				container: 'flex items-start'
			},
			defaultVariants: {
				color: 'primary',
				variant: 'list',
				indicator: 'start'
			}
		},
	}
}
